var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    { staticClass: "nut-checkbox", class: { "is-checked": _vm.isActive } },
    [
      _c("span", {
        staticClass: "checkbox-inner",
        style: _vm.checkSize,
        on: { click: _vm.checkedChange }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "checkbox-label" }, [
        _vm._v(_vm._s(_vm.label))
      ]),
      _vm._v(" "),
      _c("input", {
        attrs: { type: "checkbox", name: _vm.name },
        domProps: { checked: _vm.isActive }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }